import { render, staticRenderFns } from "./MainTransportation.vue?vue&type=template&id=9fbbdad0&"
import script from "./MainTransportation.vue?vue&type=script&lang=js&"
export * from "./MainTransportation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports